import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectMomentTypeFilter } from 'app/pages/Home/slice/selectors';
import type { RootState } from 'types';
import { subProjectMatchesMomentTypeSelection } from 'app/components/Header/momentTypeRoadmapFilter';
import { MomentData, MilestonesGridData } from '../types';

/**
 * Filter milestones grid rows by Moment Type (same rules as roadmap / ParkingLot).
 */
export const useFilterByMomentType = (
  milestonesData: MilestonesGridData | null
): MilestonesGridData | null => {
  const { selectedMomentTypes } = useSelector(selectMomentTypeFilter);
  const rsdMomentTypes = useSelector(
    (s: RootState) => s?.rsdForms?.momentTypes ?? []
  );

  return useMemo(() => {
    if (!milestonesData?.data || selectedMomentTypes.length === 0) {
      return milestonesData;
    }

    const filtered: MomentData[] = milestonesData.data.filter(moment => {
      const rawMomentType = moment.metaDetails?.momentType;
      const momentType: string | undefined =
        rawMomentType !== undefined && rawMomentType.trim() !== ''
          ? rawMomentType
          : undefined;

      return subProjectMatchesMomentTypeSelection(
        { momentType },
        selectedMomentTypes,
        rsdMomentTypes
      );
    });

    return { ...milestonesData, data: filtered };
  }, [milestonesData, selectedMomentTypes, rsdMomentTypes]);
};
